import React, { useState } from 'react';
import Proptypes from 'prop-types';
import { MdChevronRight, MdChevronLeft } from 'react-icons/md';
import ReactCardFlip from 'react-card-flip';
import Trend from 'react-trend';
import NFTVideo from '../../NFTVideo';

import {
  CardWrapper,
  BodyWrapper,
  HeaderWrapper,
  AuthorBlock,
  Name,
  Title,
  Date,
  AvatarWrapper,
  TitleBlock,
  ActionBlock,
  MediaWrapper,
  MediaBody,
  FooterWrapper,
  MetaInventory,
  MetaTagImg,
  MetaPrice,
  CardBackHeader,
  CardBackTitle,
  CardBackDate,
  CardBackContentWrapper,
  CardBackContentInner,
  CollectionWrapper,
} from './styles';

const NftCard = ({ cardData }) => {
  const [flipped, setFlipped] = useState(false);
  const [autoDraw, setAutoDraw] = useState(false);

  const handleCardFlip = () => {
    setFlipped(!flipped);
    setAutoDraw(!autoDraw);
  };

  const {
    author: {
      firstName,
      lastName,
      title,
      avatarUrl,
    },
    coverMedia: {
      coverImageURL,
      videoUrl,
    },
    details: {
      about,
      collection,
    },
    collection: {
      name,
    },
    chainInfo: {
      inventory,
      price,
    },
  } = cardData;
  return (
    <ReactCardFlip isFlipped={flipped}>
      <CardWrapper>
        <BodyWrapper>
          <HeaderWrapper>
            <AuthorBlock>
              <AvatarWrapper
                imageUrl={avatarUrl}
              />
              <TitleBlock>
                <Name>
                  {firstName}
                  <span>{lastName}</span>
                </Name>
                <Title>
                  {title}
                </Title>
                <Date>
                  Collection:&nbsp;
                  {name}
                </Date>
              </TitleBlock>
            </AuthorBlock>
            <ActionBlock onClick={() => handleCardFlip()}>
              <span>back</span>
              <MdChevronRight />
            </ActionBlock>
          </HeaderWrapper>
          <MediaWrapper>
            <MediaBody>
              <NFTVideo urlMetadata={videoUrl} />
            </MediaBody>
          </MediaWrapper>
          <FooterWrapper>
            <MetaInventory>
              {inventory}
            </MetaInventory>
            <MetaTagImg>
              <img src="https://res.cloudinary.com/scall/image/upload/v1615405392/sCallProfiles/amadeu_test/Signature_tag_xlchgz.png" alt="Signature Tag" />
            </MetaTagImg>
            <MetaPrice>
              {price}
            </MetaPrice>
          </FooterWrapper>
        </BodyWrapper>
      </CardWrapper>
      <CardWrapper>
        <BodyWrapper>
          <CardBackHeader>
            <ActionBlock onClick={() => handleCardFlip()}>
              <MdChevronLeft />
              <span>front</span>
            </ActionBlock>
          </CardBackHeader>
          <CardBackTitle>
            The
            <span>moment</span>
          </CardBackTitle>
          <CardBackDate>
            Wednesday, March 10, 2021
          </CardBackDate>
          <CardBackContentWrapper>
            <CardBackContentInner>
              <p>
                {about}
              </p>
            </CardBackContentInner>
          </CardBackContentWrapper>
          <CollectionWrapper>
            <CardBackTitle>
              in
              <span>collection</span>
            </CardBackTitle>
            <div>
              {name}
            </div>
          </CollectionWrapper>
          <CardBackTitle>
            Sales
            <span>trend</span>
          </CardBackTitle>
          <Trend
            smooth
            autoDraw={autoDraw}
            autoDrawDuration={3000}
            autoDrawEasing="ease-out"
            data={[0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0]}
            gradient={['#00c6ff', '#F0F', '#FF0']}
            radius={10}
            strokeWidth={2}
            strokeLinecap="butt"
          />
        </BodyWrapper>
      </CardWrapper>
    </ReactCardFlip>
  );
};

NftCard.propTypes = {
  cardData: Proptypes.objectOf().isRequired,
};

export default NftCard;
